import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { BusinessUnitModel } from '../../business-unit.model';
import { FicQRAction } from '../../../../../app-cordova/app/fic-services/fic-scan-qr-code.service';

@Component({
    selector: 'fi-business-unit-qr-code-view',
    templateUrl: './business-unit-qr-code-view.component.html',
    styleUrls: ['./business-unit-qr-code-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-unit-qr-code-view' },
    standalone: false,
})
export class FiBusinessUnitQRCodeViewComponent {
    @Input() businessUnit: BusinessUnitModel;
    @Input() buttonEnabled: boolean = true;
    @Input() showCode: boolean = false;
    @Input() qrCodeWidth: number = 116;
    @Output() showCodeChange = new EventEmitter<boolean>();

    onShowCodeChange(flag: boolean) {
        this.showCode = flag;
        this.showCodeChange.emit(flag);
    }

    getQRCodeData() {
        return FicQRAction.getQRCodeForBusinessUnit(this.businessUnit);
    }
}
